export const URLS = {
	MORTALITY_CAUSES: 'analises/mortalidade-por-causa/',
	API_ESTABELECIMENTO: process.env.VUE_APP_URL_API_ESTABELECIMENTO,
	TIPO_COMEDOURO: 'tipoComedouro/',
	TIPO_BEBEDOURO: 'tipoBebedouro/',
	TIPO_PISO: 'tipoPiso/',
	TECHNICAL_MANAGERS: 'responsavel-tecnico/responsavel_tecnico_ativo/',
	UNIDADE_EXPLORACAO: 'unidadeExploracao/',
	ESTABELECIMENTO: 'estabelecimento/',
	ESTABELECIMENTO_LOTES_ATIVOS: 'lote-producao/estabelecimento_lotes_ativos/'
};
